export function validateOrigin(origin: string): boolean {
  try {
    const { hostname } = new URL(origin);

    return hostname === 'cian.ru' || hostname.endsWith('.cian.ru');
  } catch (ex) {
    return false;
  }
}
